// react
import { useTranslation } from "react-i18next";
// mui
import { IconButton, Box, useTheme } from "@mui/material";
// import { IconButton, Box, useTheme, Accordion, AccordionSummary, AccordionDetails, Button, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

// src
import Icon from "../Icon";
import Draggable from "react-draggable";
import Close_Outline from "../../../images/icons/neutral_edit/Close Outline.svg";
import Check from "../../../images/icons/white_edit/Check_white.svg";
import { useContext, useEffect, useState } from "react";
import {
  EDisplayType,
  ProjectDetailContext,
} from "./Interfaces/ProjectDetailInterfaces";
import { Common } from "../../../common/src";

type Props = {
  openProjectState: boolean;
  toggleProjectState: (newVal?: boolean) => void;
  toolBarShow: boolean;
  pix4dErrorMessage: string;
  pix4dErrorCode: number;
};

const ProjectState = (props: Props) => {
  const { t } = useTranslation();
  const { projectDetail, displayType } = useContext(ProjectDetailContext);
  const [sfmShowError, setShowSfmError] = useState(false);
  const [uploadComp, setUploadComp] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);
  const [SfMComp, setSfMComp] = useState(false);
  const [SfMFailed, setSfMFailed] = useState(false);
  const [HelmertComp, setHelmertComp] = useState(false);
  const [HelmertFailed, setHelmertFailed] = useState(false);
  const [AccuracyComp, setAccuracyComp] = useState(false);
  const [DashBoardComp, setDashBoardComp] = useState(false);

  useEffect(() => {
    setUploadComp(false);
    setSfMComp(false);
    setSfMFailed(false);
    setHelmertComp(false);
    setHelmertFailed(false);
    setAccuracyComp(false);
    setDashBoardComp(false);

    if (
      projectDetail?.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      setUploadFailed(true);
    }

    if (
      projectDetail?.status.lidar_upload ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.sfm_processing ===
        Common.PROJECT_STATUS_ENUM.PROCESSING ||
      projectDetail?.status.sfm_processing ===
        Common.PROJECT_STATUS_ENUM.WAITING
    ) {
      setUploadComp(true);
    }

    if (
      projectDetail?.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      setSfMFailed(true);
    }

    if (
      projectDetail?.status.sfm_processing ===
      Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      setSfMComp(true);
    }

    if (
      projectDetail?.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR ||
      projectDetail?.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      setHelmertFailed(true);
    }

    if (
      projectDetail?.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      setHelmertComp(true);
    }

    if (
      projectDetail?.status.verification_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.verification_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      setAccuracyComp(true);
    }

    if (
      projectDetail?.status.dashboard_upload_las_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.dashboard_upload_las_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.dashboard_upload_txt_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.dashboard_upload_txt_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.landlog_viewer_upload_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      projectDetail?.status.landlog_viewer_upload_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      setDashBoardComp(true);
    }
  }, [projectDetail?.status]);

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackground = {
    background: theme.palette.base.opacityMain,
  };

  return (
    <div>
      {props.openProjectState && (
        <Draggable handle=".drag-handle" cancel=".non-drag">
          <div
            className="pj-div"
            style={{
              top: displayType === EDisplayType.Web ? "85px" : "40px",
              height: 0,
            }}
          >
            <div className="project-state1">
              {/* ボタン */}
              <IconButton
                className={`${
                  props.toolBarShow ? "state-top2" : ""
                } project-state2`}
                size="small"
                onClick={(e) => {
                  props.toggleProjectState();
                }}
              >
                <Icon imagePath={Close_Outline} color={customColor.color} />
              </IconButton>
            </div>
            <Box
              style={customBackground}
              className={`drag-handle ${
                props.toolBarShow ? "state-top2" : "state-top1"
              } project-state4`}
            >
              <Box className="project-state5">
                {uploadComp ? (
                  <div
                    className="project-state6"
                    style={{ ...customColor, ...customBackground }}
                  >
                    <div className="project-state7 project-state8">
                      <img src={Check} alt="" />
                    </div>
                    <div className="project-state9">{t("UPLOAD_COMPLETE")}</div>
                  </div>
                ) : uploadFailed ? (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state12">1</div>
                    <div className="project-state13">{t("UPLOAD_ERROR")}</div>
                  </div>
                ) : (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state10">1</div>
                    <div className="project-state11">
                      {t("UPLOAD_COMPLETE")}
                    </div>
                  </div>
                )}
              </Box>

              <Box className="project-state5">
                {SfMComp ? (
                  <div
                    className="project-state6"
                    style={{ ...customColor, ...customBackground }}
                  >
                    <div className="project-state7 project-state8">
                      <img src={Check} alt="" />
                    </div>
                    <div className="project-state9">{t("PROCESSING_DONE")}</div>
                  </div>
                ) : SfMFailed ? (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state12">2</div>
                    <div className="project-state13">
                      {t("SFM_PROCESSING_ERROR")}
                    </div>
                  </div>
                ) : (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state10">2</div>
                    <div className="project-state11">
                      {t("PROCESSING_DONE")}
                    </div>
                  </div>
                )}
              </Box>

              {/* {SfMComp ? (
                <Box className="project-state5">
                  <div className="project-state6" style={{ ...customColor, ...customBackground }}>
                    <div className="project-state7 project-state8"><img src={Check} alt="" /></div>
                    <div className='project-state9'>{t("PROCESSING_DONE")}</div>
                  </div>
                </Box>
              ) :
                SfMFailed ? (
                  // <Accordion className="project-accordion" style={customBackground} expanded={errorAccordionExpanded}>
                  //   <AccordionSummary
                  //     aria-controls="panel1a-content"
                  //     id="panel1a-header"
                  //     expandIcon={<ExpandMoreIcon />}
                  //   >
                  //     <div className="project-state6" >
                  //       <div className="project-state7 project-state12">2</div>
                  //       <div className='project-state13'>{t("SFM_PROCESSING_ERROR")}</div>
                  //     </div>
                  //   </AccordionSummary>
                  //   <AccordionDetails>
                  //     <p>{props.pix4dErrorCode !== undefined && props.pix4dErrorCode !== null && [500, 400, 401, 402, 403, 404, 405].includes(props.pix4dErrorCode) ? t(props.pix4dErrorCode.toString()) : null}</p>
                  //   </AccordionDetails>
                  // </Accordion>

                  <Box
                    style={{ ...customColor, ...customBackground }}
                    className="project-state5"
                  >
                    <div className="project-state6" style={{ display: "flex" }} >
                      <div className="project-state7 project-state12">2</div>
                      <div className='project-state13'>{t("SFM_PROCESSING_ERROR")}</div>
                      {
                        props.pix4dErrorCode &&
                        (
                          sfmShowError ?
                            // iosでclickできるようdrag-handleは付けない
                            <ExpandLessIcon className="non-drag" style={{ marginLeft: "15px" }} onClick={e => { setShowSfmError(!sfmShowError) }} />
                            :
                            <ExpandMoreIcon className="non-drag" style={{ marginLeft: "15px" }} onClick={e => { setShowSfmError(!sfmShowError) }} />
                        )
                      }
                    </div>
                    {
                      sfmShowError &&
                      <div className='project-state14'>
                        {
                          props.pix4dErrorCode &&
                            [500, 400, 401, 402, 403, 404, 405].includes(props.pix4dErrorCode) ?
                            <div>
                              {props.pix4dErrorMessage}
                              {": "}
                              {t(props.pix4dErrorCode.toString())}
                            </div>
                            :
                            null
                        }
                      </div>
                    }
                  </Box>
                ) : (
                  <Box className="project-state5">
                    <div className="project-state6" style={customBackground}>
                      <div className="project-state7 project-state10">2</div>
                      <div className='project-state11'>{t("PROCESSING_DONE")}</div>
                    </div>
                  </Box>
                )
              } */}

              <Box className="project-state5">
                {HelmertComp ? (
                  <div
                    className="project-state6"
                    style={{ ...customColor, ...customBackground }}
                  >
                    <div className="project-state7 project-state8">
                      <img src={Check} alt="" />
                    </div>
                    <div className="project-state9">
                      {t("COORDINATE_CHANGE_COMPLETE")}
                    </div>
                  </div>
                ) : HelmertFailed ? (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state12">3</div>
                    <div className="project-state13">
                      {t("COORDINATE_CHANGE_ERROR")}
                    </div>
                  </div>
                ) : (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state10">3</div>
                    <div className="project-state11">
                      {t("COORDINATE_CHANGE_COMPLETE")}
                    </div>
                  </div>
                )}
              </Box>

              <Box className="project-state5">
                {AccuracyComp ? (
                  <div
                    className="project-state6"
                    style={{ ...customColor, ...customBackground }}
                  >
                    <div className="project-state7 project-state8">
                      <img src={Check} alt="" />
                    </div>
                    <div className="project-state9">
                      {t("ACCURACY_VERIFY_COMP")}
                    </div>
                  </div>
                ) : (
                  <div className="project-state6" style={customBackground}>
                    <div className="project-state7 project-state10">4</div>
                    <div className="project-state11">
                      {t("ACCURACY_VERIFY_COMP")}
                    </div>
                  </div>
                )}
              </Box>
              <Box className="project-state5">
                {DashBoardComp ? (
                  <div
                    className="project-state6"
                    style={{ ...customColor, ...customBackground }}
                  >
                    <div className="project-state7 project-state_dashboard">
                      <img src={Check} alt="" />
                    </div>
                    <div className="project-state9">
                      {t("DASHBOARD_UPLOAD_COMPLETE")}
                    </div>
                  </div>
                ) : (
                  <div
                    className="project-state6"
                    style={{ ...customBackground }}
                  >
                    <div className="project-state7 project-state10">5</div>
                    <div className="project-state11">
                      {t("DASHBOARD_UPLOAD_COMPLETE")}
                    </div>
                  </div>
                )}
              </Box>
            </Box>
          </div>
        </Draggable>
      )}
    </div>
  );
};

export default ProjectState;
